import { render, staticRenderFns } from "./PlatformConfigureProgram.vue?vue&type=template&id=73556f56&scoped=true&"
import script from "./PlatformConfigureProgram.vue?vue&type=script&lang=js&"
export * from "./PlatformConfigureProgram.vue?vue&type=script&lang=js&"
import style0 from "./PlatformConfigureProgram.vue?vue&type=style&index=0&id=73556f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73556f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VHover,VRadio,VRadioGroup,VRow})
